import { mapGetters, mapMutations } from 'vuex'
import { getKeyCodeName } from '_lib/utils/utils'
import { CONFLICT_SHORTCUT_DEFAULT_CONFIG } from '@/common/constants/config'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'setting_data'
    ])
  },
  methods: {
    getKeyName(v, type, join) {
      return getKeyCodeName(v, type, join, this.configCheck)
    },
    configCheck() {
      let l = Object.keys(CONFLICT_SHORTCUT_DEFAULT_CONFIG)
      let config = this.setting_data;
      for (let k of l) {
        if (config[k] !== '' && typeof config[k] !== 'object') {
          let obj = []
          obj[k] = ''
          this.SET_SETTING_DATA_PARAM(obj)
        }
      }
    },
    ...mapMutations([
      'SET_SETTING_DATA_PARAM'
    ])
  },
}
